// 生产环境 https://xos-iot.li-gong.com
const productionEnv = `https://xos-iot.li-gong.com`;
const developmentEnv = `https://xosiot.li-gong.com`;
// const xianEnv = `http://xos-app-c1:8081`;

export const baseUrls = {
    aio: process.env.NODE_ENV === 'production' ? productionEnv : developmentEnv,
};